import React from 'react'
import PropTypes from 'prop-types'
import RpModal from 'portal-modules/common/components/modals/rp-modal'
import { StyledButton, StyledButtonDiv } from '../atoms'
import { connect } from 'react-redux'

const StackRenewalValidationModal = (props, { isLeaseAndRentWordReplaced }) => (
  <RpModal
    {...props}
    title={__('Message')}
    footerContent={
      <StyledButtonDiv>
        <StyledButton appearance='primary' onClick={props.onClose}>
          {__('Cancel')}
        </StyledButton>
      </StyledButtonDiv>
    }
  >
    <span>
      {__(
        'There is a renewal offer(s) associated with this {%s, 0}. Cancel the stacked renewal before scheduling the renewal transfer',
        [isLeaseAndRentWordReplaced ? 'housing agreement' : 'lease'],
      )}
    </span>
  </RpModal>
)

StackRenewalValidationModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isLeaseAndRentWordReplaced: PropTypes.bool,
}

export default connect(({ productPermissions: { replace_lease_and_rent } }) => {
  return {
    isLeaseAndRentWordReplaced: replace_lease_and_rent || false,
  }
})(StackRenewalValidationModal)
